import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Input from "../../../../../../components/forms-fields/Input";
import { addNutritionHydration } from "../../../../../../schemas";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { POST_CARE_PLAN_URL, BASE_URL_PROD, ADMIN_ID } from "../../../../../../env";
import Plat from "../../../../../../assets/images/Plat.png";
import Glass from "../../../../../../assets/images/Glass.png";
import ReactDOMServer from 'react-dom/server';
import {
  postRecords,
  catchAsync,
  isSuccess,
  toastSuccessMessages,
  toastErrorMessages,
} from "../../../../../../helper/helper";
import CustomSelect from "../../../../../../components/forms-fields/CustomSelectStaffMembers";
import TextArea from "../../../../../../components/forms-fields/TextArea";
import moment from "moment";
import { Link } from "react-router-dom";
import Layout from "../../../../../../components/layouts/Layout";
import { Form } from "react-bootstrap";

function AddNutritionHydration() {
  const storedUserDetails = localStorage.getItem("profileUserDetails");
  const userDetails = JSON.parse(storedUserDetails);
  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
  const [isToastAddCarePlans, setIsToastAddCarePlans] = useState(false);


  const [suFormData, setSuFormData] = useState({
    addedby: ADMIN_ID,
    nutritionHydrationType: "Food",
    foodFluidType: "",
    foodFluidAmount: "",
    comments: "",
    eventDateTime: moment().valueOf(),
  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
  } = useFormik({
    initialValues: suFormData,
    validationSchema: addNutritionHydration,
    onSubmit: async (values) => {
      try {
        setIsSubmitButtonClicked(true);
        await postAddCarePlansFormData(values);
      } catch (error) {
        
      }
    },
  });

  const processPostRecords = (method, data) => {
    if (data?.status !== isSuccess) {
      setIsToastAddCarePlans(true);
      toastErrorMessages(toast.error, data?.message, "", 10, 10);
      setIsSubmitButtonClicked(false);

    } else if (
      method === "postAddCarePlansFormData" &&
      data?.status === isSuccess
    ) {
      setIsToastAddCarePlans(true);
      toastSuccessMessages(toast.success, data?.message, "/care-plan/general-notes", 10, 10);
      setIsSubmitButtonClicked(false);
    }
  };

  const postAddCarePlansFormData = catchAsync(async (req, res) => {
    const noteDetailsString = ReactDOMServer.renderToString(htmlData);
    const updateValues = {
      userId: userDetails?._id,
      addedby: ADMIN_ID,
      noteType: "NutritionHydration",
      isHTML: true,
      title: values?.comments,
      flag: false,
      noteDetails: noteDetailsString,
      eventDateTime: moment(values.eventDateTime).valueOf(),
    }

    
    const response = await postRecords(POST_CARE_PLAN_URL, updateValues);
    
    setIsSubmitButtonClicked(false);
    processPostRecords("postAddCarePlansFormData", response);
  });



  const handleInputChangePrevFields = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });

    handleChange(e);
    handleBlur(e);
  };




  const [htmlData, setHtmlData] = useState("")

  // Food type check boxes list
  const [nutritionHydrationType, setNutritionHydrationType] = useState([
    { id: 1, value: "Food", label: "Food", },
    { id: 2, value: "Fluid", label: "Fluid", },
  ]);


  useEffect(() => {
    setHtmlData(
      <>
        <div className="col-md-12">
          <p className="text-left"><strong>Type: </strong><span id="nutritionHydrationTypeData">{values?.nutritionHydrationType}</span></p>
        </div>
        <div className="col-md-6">
          <p className="text-left"><strong>{values?.nutritionHydrationType === "Food" ? "Meal Type: (Breakfast, Lunch, Dinner, Snack etc)" : values?.nutritionHydrationType === "Fluid" ? "Drink Type" : ""}: </strong><span id="foodFluidTypeData">{values?.foodFluidType}</span></p>
        </div>
        <div className="col-md-6">
          <p className="text-left"><strong>{values?.nutritionHydrationType === "Food" ? "Amount Eaten" : values?.nutritionHydrationType === "Fluid" ? "Amount (ML)" : ""}: </strong><span id="foodFluidAmountData">{values?.foodFluidAmount} </span></p>
        </div>

        <div className="col-md-12">
          <p><strong>Comments: </strong><span id="commentsData">{values?.comments !== "" ? values?.comments : "No assistance requried"}</span></p>
        </div>
        <div className="col-md-12">
          {values?.nutritionHydrationType === "Food" ? (
            <img className="observationImg" src={BASE_URL_PROD + Plat} alt="Plat" />
          ) : values?.nutritionHydrationType === "Fluid" ? (
            <img className="observationImg" src={BASE_URL_PROD + Glass} alt="Glass" />
          ) : ""}

        </div>
      </>
    );
  }, [values]);

  return (

    <>
      <Layout pageTitleText="Notes">
        <div className="incidents consentCapacityAddNew">
          <div className="mainContent ">
            <div className="mainContentText">
              <h3>Add Nutrition Hydration note</h3>
              <form onSubmit={handleSubmit}>
                <div className="formBlockContent">
                  <div className="row">


                    <div className="col-md-6">
                      <Input
                        type="datetime-local"
                        id="eventDateTime"
                        name="eventDateTime"
                        value={moment(values?.eventDateTime).format('YYYY-MM-DDTHH:mm')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        labelText="Date / Time"
                        customError={touched?.eventDateTime && errors?.eventDateTime}
                        errorMessage={errors?.eventDateTime}
                        erroClass={
                          touched?.eventDateTime && errors?.eventDateTime
                            ? "validationError"
                            : ""
                        }
                        requiredStar={true}
                      />

                    </div>

                    <div className="col-md-12 mb-3">
                      <div className="checkboxList spaceInCheckList">
                        {nutritionHydrationType.map((row, index) => (
                          <>
                            <Form.Check
                              name="nutritionHydrationType"
                              id={row?.label}
                              type="radio"
                              label={row?.label}
                              value={row?.value}
                              onClick={() => setValues(prevState => ({ ...prevState, nutritionHydrationType: row?.value }))}
                              checked={values?.nutritionHydrationType === row?.label && true}
                              onChange={handleInputChangePrevFields}
                              onBlur={handleBlur}
                            />
                          </>
                        ))}

                      </div>
                    </div>


                    <div className="col-md-6">
                      <Input
                        type="text"
                        id="foodFluidType"
                        name="foodFluidType"
                        value={values?.foodFluidType}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        labelText={values?.nutritionHydrationType === "Food" ? "Meal Type: (Breakfast, Lunch, Dinner, Snack etc)" : values?.nutritionHydrationType === "Fluid" ? "Drink Type" : ""}
                        customError={touched?.foodFluidType && errors?.foodFluidType}
                        errorMessage={errors?.foodFluidType}
                        erroClass={
                          touched?.foodFluidType && errors?.foodFluidType
                            ? "validationError"
                            : ""
                        }
                        requiredStar={true}
                      />

                    </div>

                    <div className="col-md-6">
                      <Input
                        type="text"
                        id="foodFluidAmount"
                        name="foodFluidAmount"
                        value={values?.foodFluidAmount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        labelText={values?.nutritionHydrationType === "Food" ? "Amount Eaten" : values?.nutritionHydrationType === "Fluid" ? "Amount (ML)" : ""}
                        customError={touched?.foodFluidAmount && errors?.foodFluidAmount}
                        errorMessage={errors?.foodFluidAmount}
                        erroClass={
                          touched?.foodFluidAmount && errors?.foodFluidAmount
                            ? "validationError"
                            : ""
                        }
                        requiredStar={true}
                      />

                    </div>
                    <div className="col-md-12">
                      <TextArea
                        id="comments"
                        name="comments"
                        value={values?.comments}
                        onChange={handleInputChangePrevFields}
                        onBlur={handleBlur}
                        labelText="Comments"
                        rows="3"
                        className="mb-0"
                        customError={touched?.comments && errors?.comments}
                        errorMessage={errors?.comments}
                        erroClass={
                          touched?.comments && errors?.comments
                            ? "validationError"
                            : ""
                        }
                        requiredStar={true}
                      />
                    </div>

                  </div>
                </div>

                <div className="formActionButtons">
                  <Link
                    to={"/care-plan/general-notes"}
                    className="btn btn-sm btn-outline-primary"
                  >
                    Back
                  </Link>

                  {isSubmitButtonClicked ? (
                    <Button
                      className="btn-sm"
                      variant="primary"
                      disabled
                    >
                      Loading...
                    </Button>
                  ) : (
                    <Button className="btn-sm" variant="primary" type="submit">
                      Submit
                    </Button>
                  )}
                </div>
              </form>

              {isToastAddCarePlans && <ToastContainer />}
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}


export default AddNutritionHydration